import React from 'react';
import { SearchCard } from '../components/SearchCard';
import { useNavigate } from 'react-router-dom';
import { Bus, Train, Plane, Ship, MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
export function HomePage() {
  const navigate = useNavigate();
  const categories = [{
    icon: Bus,
    label: 'বাস',
    color: 'bg-[#006a4e]/10 text-[#006a4e]'
  }, {
    icon: Train,
    label: 'ট্রেন',
    color: 'bg-orange-100 text-orange-600'
  }, {
    icon: Ship,
    label: 'লঞ্চ',
    color: 'bg-indigo-100 text-indigo-600'
  }, {
    icon: Plane,
    label: 'বিমান',
    color: 'bg-sky-100 text-sky-600'
  }];
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-215">
      {/* Header */}
      <header className="bg-[#006a4e] text-white p-6 pb-12 rounded-b-[2.5rem] shadow-lg relative overflow-hidden" data-id="element-216">
        <div className="absolute top-0 right-0 w-32 h-32 bg-white opacity-10 rounded-full -mr-10 -mt-10" data-id="element-217" />
        <div className="absolute bottom-0 left-0 w-24 h-24 bg-white opacity-10 rounded-full -ml-10 -mb-10" data-id="element-218" />

        <div className="relative z-10" data-id="element-219">
          <div className="flex justify-between items-center mb-6" data-id="element-220">
            <div className="flex items-center space-x-2" data-id="element-221">
              <div className="w-8 h-8 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm" data-id="element-222">
                <span className="text-lg" data-id="element-223">🇧🇩</span>
              </div>
              <span className="font-bold text-lg" data-id="element-224">OneTicket</span>
            </div>
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm" data-id="element-225">
              <span className="text-xl" data-id="element-226">👤</span>
            </div>
          </div>

          <h1 className="text-3xl font-bold font-bengali mb-2" data-id="element-227">
            কোথায় যেতে চান?
          </h1>
          <p className="text-green-100 font-bengali" data-id="element-228">
            আপনার নিরাপদ যাত্রার সঙ্গী
          </p>
        </div>
      </header>

      <div className="px-4 -mt-8 relative z-20" data-id="element-229">
        <SearchCard onSearch={() => navigate('/results')} data-id="element-230" />
      </div>

      <div className="px-5 mt-8" data-id="element-231">
        <h2 className="font-bold text-gray-900 font-bengali text-xl mb-4" data-id="element-232">
          জনপ্রিয় মাধ্যম
        </h2>
        <div className="grid grid-cols-4 gap-3" data-id="element-233">
          {categories.map((cat, idx) => <motion.button key={idx} whileTap={{
          scale: 0.95
        }} className="flex flex-col items-center space-y-2" data-id="element-234">
              <div className={`w-16 h-16 rounded-2xl flex items-center justify-center shadow-sm ${cat.color}`} data-id="element-235">
                <cat.icon size={28} data-id="element-236" />
              </div>
              <span className="text-sm font-medium font-bengali text-gray-700" data-id="element-237">
                {cat.label}
              </span>
            </motion.button>)}
        </div>
      </div>

      <div className="px-5 mt-8 mb-8" data-id="element-238">
        <h2 className="font-bold text-gray-900 font-bengali text-xl mb-4" data-id="element-239">
          সাম্প্রতিক গন্তব্য
        </h2>
        <div className="flex space-x-4 overflow-x-auto no-scrollbar pb-2" data-id="element-240">
          {['কক্সবাজার', 'সিলেট', 'সাজেক'].map((place, idx) => <div key={idx} className="min-w-[140px] h-20 bg-white rounded-xl border border-gray-100 flex items-center p-3 space-x-3 shadow-sm" data-id="element-241">
              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center text-gray-500" data-id="element-242">
                <MapPin size={18} data-id="element-243" />
              </div>
              <span className="font-medium font-bengali text-gray-800" data-id="element-244">
                {place}
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}